import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleLineChart = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7 14L10.5 10.5L12 12L13.5 13.5L17 10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCircleLineChart.js.map